<div class="container-scroller">
  <div class="container-fluid page-body-wrapper full-page-wrapper">
    <div class="content-wrapper d-flex align-items-stretch auth auth-img-bg">
      <div class="row flex-grow">
        <div class="col-lg-6 d-flex align-items-center justify-content-center">
          <div class="auth-form-transparent text-left p-3">
            <div class="brand-logo text-center">
              <img src="assets/images/logo.png" alt="logo" />
            </div>
            <!-- <h4>Welcome back!</h4>
            <h6 class="font-weight-light">Happy to see you again!</h6> -->
            <form class="pt-3" [formGroup]="loginForm">
              <div
                class="alert alert-danger text-center"
                role="alert"
                *ngIf="errorMessage"
              >
                <strong>{{errorMessage}}</strong>
              </div>
              <div class="form-group">
                <label class="small mb-1" for="companyName">Company Name</label>
                <select
                  class="form-control form-control-lg"
                  formControlName="companyName"
                  [ngClass]="{'invalid': submitted && f.companyName.errors, 'valid' : submitted && !f.companyName.errors && errorMessage==''}"
                >
                  <option
                    *ngFor="let companyName of companyNames"
                    [value]="companyName.CM_ID"
                    >{{companyName.CM_NAME}}</option
                  >
                </select>
              </div>
              <!-- <div class="form-group">
                <label class="small mb-1" for="financialYear"
                  >Financial Year</label
                >
                <select
                  class="form-control form-control-lg"
                  formControlName="financialYear"
                  [ngClass]="{'invalid': submitted && f.financialYear.errors, 'valid' : submitted && !f.financialYear.errors && errorMessage==''}"
                >
                  <option
                    *ngFor="let companyMaster of companyMasterDetails"
                    [value]="companyMaster.CM_CODE"
                    >From {{companyMaster.CM_OPENING_DATE | date : 'dd/MM/y'}}
                    To {{companyMaster.CM_CLOSING_DATE | date : 'dd/MM/y'}}
                  </option>
                </select>
              </div> -->
              <div class="form-group">
                <label for="exampleInputEmail">Username</label>
                <div class="input-group">
                  <div class="input-group-prepend bg-transparent">
                    <span
                      class="input-group-text bg-transparent border-right-0"
                    >
                      <i class="mdi mdi-account-outline text-primary"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control form-control-lg border-left-0"
                    id="username"
                    placeholder="Username"
                    formControlName="username"
                    [ngClass]="{'invalid': submitted && f.username.errors, 'valid' : submitted && !f.username.errors && errorMessage==''}"
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="exampleInputPassword">Password</label>
                <div class="input-group">
                  <div class="input-group-prepend bg-transparent">
                    <span
                      class="input-group-text bg-transparent border-right-0"
                    >
                      <i class="mdi mdi-lock-outline text-primary"></i>
                    </span>
                  </div>
                  <input
                    type="password"
                    class="form-control form-control-lg border-left-0"
                    id="exampleInputPassword"
                    placeholder="Password"
                    formControlName="password"
                    [ngClass]="{'invalid': submitted && f.password.errors, 'valid' : submitted && !f.password.errors   && errorMessage==''}"
                  />
                </div>
              </div>
              <!-- <div
                class="my-2 d-flex justify-content-between align-items-center"
              >
                <div class="form-check">
                  <label class="form-check-label text-muted">
                    <input type="checkbox" class="form-check-input" />
                    Keep me signed in
                  </label>
                </div>
                <a href="#" class="auth-link text-black">Forgot password?</a>
              </div> -->
              <div class="my-3">
                <button
                  class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                  (click)="onSubmit();"
                  [disabled]="isLoading"
                >
                  <i
                    [ngClass]="{'fa fa-spin fa-spinner': isLoading, 'fas fa-lock': !isLoading}"
                  ></i>
                  {{button}}
                </button>
              </div>
              <!-- <div class="mb-2 d-flex">
                  <button
                    type="button"
                    class="btn btn-facebook auth-form-btn flex-grow mr-1"
                  >
                    <i class="mdi mdi-facebook mr-2"></i>Facebook
                  </button>
                  <button
                    type="button"
                    class="btn btn-google auth-form-btn flex-grow ml-1"
                  >
                    <i class="mdi mdi-google mr-2"></i>Google
                  </button>
                </div> -->
            </form>
          </div>
        </div>
        <div class="col-lg-6 login-half-bg d-flex flex-row">
          <p
            class="text-white font-weight-medium text-center flex-grow align-self-end"
          >
            Copyright &copy; 2021 All rights reserved.
          </p>
        </div>
      </div>
    </div>
    <!-- content-wrapper ends -->
  </div>
  <!-- page-body-wrapper ends -->
</div>
